/* eslint-disable no-console */
class CounterLog {
    private _stack: string[][] = [];

    constructor() {}

    log(key: string, value: string) {
        this._stack.push([key, value]);
    }

    dump() {
        console.clear();
        console.group();
        this._stack.forEach(([key, value]) =>
            console.info(
                `%c${key}`,
                'color: white; background-color: #720055; padding: 2px 6px; border-radius: 2px;',
                value,
            ),
        );
        console.groupEnd();
    }
}

export const _counterLog = new CounterLog();

globalThis._counterLog = _counterLog;
